import { Routes } from '@angular/router';
import { authGuard } from 'projects/visa-platform/src/app/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('projects/visa-platform/src/app/pages/home/home.component').then(
        (m) => m.HomeComponent
      ),
  },
  {
    path: 'offer-details/:id/renewal-id/:renewalId',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/offer-details/offer-details.component'
      ).then((m) => m.OfferDetailsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'info/terms-and-conditions',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/terms-and-conditions/terms-and-conditions.component'
      ).then((m) => m.TermsAndConditionsComponent),
  },
  {
    path: 'info/privacy-policy',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/privacy-policy/privacy-policy.component'
      ).then((m) => m.PrivacyPolicyComponent),
  },
  {
    path: 'milestone-history',
    loadComponent: () =>
      import(
        'projects/visa-platform/src/app/pages/milestone-history/milestone-history.component'
      ).then((m) => m.MilestoneHistoryComponent),
    canActivate: [authGuard],
  },
  { path: '**', redirectTo: '', pathMatch: 'full' },
];
